import { Link } from "react-router-dom";

export default function Books() {
	return (
		<section>
			<div className="container">
				{/* row Start */}
				<div className="row">

					<div className="col-xl-8 col-lg-8 col-md-12">
						<div className="cdtsr-groups-block">

							<div className="single-cdtsr-block">
								<div className="single-cdtsr-header"><h5>PPL All Subjects Bundle (A) </h5></div>
								<div className="single-cdtsr-body align-to-left">
									<p>The SACAA is Currently updating all PPL,CPL and ATPL exams. Your urgent feedback after writing is critcal to help us improve the new database. We are releasing new updates daily as we receive feedback from students.</p>
								</div>
							</div>


							<div className="single-cdtsr-block">
								<div className="single-cdtsr-header"><h5>Categories</h5></div>
								<div className="single-cdtsr-body">
									<div className="cndts-all-skills-list">
										<span>Flight Operations</span>
										<span>Aeronautical Engineering</span>
										<span>Aircraft Maintenance</span>
										<span>Air Traffic Control</span>
										<span>Avionics Systems</span>
										<span>Cabin Crew Training</span>
										<span>Airport Management</span>
									</div>
								</div>
							</div>



							<div className="single-cdtsr-block">
								<div className="single-cdtsr-header"><h5>10 Contents</h5></div>
								<div className="single-cdtsr-body">
									{/* Start All List */}
									<div className="row justify-content-start gx-3 gy-4">

										{/* Single Item */}
										<div className="col-xl-12 col-lg-12 col-md-12">
											<div className="jbs-list-box border">
												<div className="jbs-list-head">
													<div className="jbs-list-head-thunner">
														<div className="jbs-list-emp-thumb jbs-verified"><Link to="#"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/l-1.png`} className="img-fluid" alt="" /></figure></Link></div>
														<div className="jbs-list-job-caption">
															<div className="jbs-job-types-wrap"><span className="label text-success bg-success bg-opacity-05">Full Time</span></div>
															<div className="jbs-job-title-wrap"><h4><Link to="#" className="jbs-job-title">PPL Human Performance</Link></h4></div>
															<div className="jbs-job-mrch-lists">
																<div className="single-mrch-lists">
																	<span>Test Series</span>.<span>13 Tests</span>
																</div>
															</div>
														</div>
													</div>
													<div className="jbs-list-head-middle">
														<div className="elsocrio-jbs"><div className="ilop-tr"><i className="fa-solid fa-sack-dollar"></i></div><h5 className="jbs-list-pack">₹ 5K<span className="patype">/90 Days validity</span></h5></div>
													</div>
													<div className="jbs-list-head-last">
														<Link to="#" className="btn btn-md btn-gray px-3 me-2">View Detail</Link>
														<Link to="#" className="btn btn-md btn-main px-3">Quick Apply</Link>
													</div>
												</div>
											</div>
										</div>

										{/* Single Item */}
										<div className="col-xl-12 col-lg-12 col-md-12">
											<div className="jbs-list-box border">
												<div className="jbs-list-head">
													<div className="jbs-list-head-thunner">
														<div className="jbs-list-emp-thumb"><Link to="#"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/l-2.png`} className="img-fluid" alt="" /></figure></Link></div>
														<div className="jbs-list-job-caption">
															<div className="jbs-job-types-wrap"><span className="label text-warning bg-warning bg-opacity-05">Part Time</span></div>
															<div className="jbs-job-title-wrap"><h4><Link to="#" className="jbs-job-title">PPL Air Law</Link></h4></div>
															<div className="jbs-job-mrch-lists">
																<div className="single-mrch-lists">
																	<span>Test Series</span>.<span>2 Tests</span>
																</div>
															</div>
														</div>
													</div>
													<div className="jbs-list-head-middle">
														<div className="elsocrio-jbs"><div className="ilop-tr"><i className="fa-solid fa-sack-dollar"></i></div><h5 className="jbs-list-pack">₹100K<span className="patype">/90 Days validity</span></h5></div>
													</div>
													<div className="jbs-list-head-last">
														<Link to="#" className="btn btn-md btn-gray px-3 me-2">View Detail</Link>
														<Link to="#" className="btn btn-md btn-main px-3">Quick Apply</Link>
													</div>
												</div>
											</div>
										</div>

										{/* Single Item */}
										<div className="col-xl-12 col-lg-12 col-md-12">
											<div className="jbs-list-box border">
												<div className="jbs-list-head">
													<div className="jbs-list-head-thunner">
														<div className="jbs-list-emp-thumb"><Link to="#"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/l-3.png`} className="img-fluid" alt="" /></figure></Link></div>
														<div className="jbs-list-job-caption">
															<div className="jbs-job-types-wrap"><span className="label text-success bg-success bg-opacity-05">Full Time</span></div>
															<div className="jbs-job-title-wrap"><h4><Link to="#" className="jbs-job-title">PPL Meteorology</Link></h4></div>
															<div className="jbs-job-mrch-lists">
																<div className="single-mrch-lists">
																	<span>Test Series</span>.<span>15 Tests</span>
																</div>
															</div>
														</div>
													</div>
													<div className="jbs-list-head-middle">
														<div className="elsocrio-jbs"><div className="ilop-tr"><i className="fa-solid fa-sack-dollar"></i></div><h5 className="jbs-list-pack">₹115K<span className="patype">/10 Days validity</span></h5></div>
													</div>
													<div className="jbs-list-head-last">
														<Link to="#" className="btn btn-md btn-gray px-3 me-2">View Detail</Link>
														<Link to="#" className="btn btn-md btn-main px-3">Quick Apply</Link>
													</div>
												</div>
											</div>
										</div>

										{/* Single Item */}
										<div className="col-xl-12 col-lg-12 col-md-12">
											<div className="jbs-list-box border">
												<div className="jbs-list-head">
													<div className="jbs-list-head-thunner">
														<div className="jbs-list-emp-thumb jbs-verified"><Link to="#"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/l-4.png`} className="img-fluid" alt="" /></figure></Link></div>
														<div className="jbs-list-job-caption">
															<div className="jbs-job-types-wrap"><span className="label text-success bg-success bg-opacity-05">Full Time</span></div>
															<div className="jbs-job-title-wrap"><h4><Link to="#" className="jbs-job-title">PPL Principles of Flight (A)</Link></h4></div>
															<div className="jbs-job-mrch-lists">
																<div className="single-mrch-lists">
																	<span>Test Series</span>.<span>20 Tests</span>
																</div>
															</div>
														</div>
													</div>
													<div className="jbs-list-head-middle">
														<div className="elsocrio-jbs"><div className="ilop-tr"><i className="fa-solid fa-sack-dollar"></i></div><h5 className="jbs-list-pack">₹110K<span className="patype">/40 Days validity</span></h5></div>
													</div>
													<div className="jbs-list-head-last">
														<Link to="#" className="btn btn-md btn-gray px-3 me-2">View Detail</Link>
														<Link to="#" className="btn btn-md btn-main px-3">Quick Apply</Link>
													</div>
												</div>
											</div>
										</div>

										{/*- Single Item */}
										<div className="col-xl-12 col-lg-12 col-md-12">
											<div className="jbs-list-box border">
												<div className="jbs-list-head">
													<div className="jbs-list-head-thunner">
														<div className="jbs-list-emp-thumb"><Link to="#"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/l-5.png`} className="img-fluid" alt="" /></figure></Link></div>
														<div className="jbs-list-job-caption">
															<div className="jbs-job-types-wrap"><span className="label text-danger bg-danger bg-opacity-05">Enternship</span></div>
															<div className="jbs-job-title-wrap"><h4><Link to="#" className="jbs-job-title">PPL Aircraft Technical and Generel (A)</Link></h4></div>
															<div className="jbs-job-mrch-lists">
																<div className="single-mrch-lists">
																	<span>Test Series</span>.<span>20 Tests</span>
																</div>
															</div>
														</div>
													</div>
													<div className="jbs-list-head-middle">
														<div className="elsocrio-jbs"><div className="ilop-tr"><i className="fa-solid fa-sack-dollar"></i></div><h5 className="jbs-list-pack">₹120K<span className="patype">/10 Days validity</span></h5></div>
													</div>
													<div className="jbs-list-head-last">
														<Link to="#" className="btn btn-md btn-gray px-3 me-2">View Detail</Link>
														<Link to="#" className="btn btn-md btn-main px-3">Quick Apply</Link>
													</div>
												</div>
											</div>
										</div>

										{/* Single Item */}
										<div className="col-xl-12 col-lg-12 col-md-12">
											<div className="jbs-list-box border">
												<div className="jbs-list-head">
													<div className="jbs-list-head-thunner">
														<div className="jbs-list-emp-thumb"><Link to="#"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/l-6.png`} className="img-fluid" alt="" /></figure></Link></div>
														<div className="jbs-list-job-caption">
															<div className="jbs-job-types-wrap"><span className="label text-success bg-success bg-opacity-05">Full Time</span></div>
															<div className="jbs-job-title-wrap"><h4><Link to="#" className="jbs-job-title">PPL Navigation</Link></h4></div>
															<div className="jbs-job-mrch-lists">
																<div className="single-mrch-lists">
																	<span>Test Series</span>.<span>18 Tests</span>
																</div>
															</div>
														</div>
													</div>
													<div className="jbs-list-head-middle">
														<div className="elsocrio-jbs"><div className="ilop-tr"><i className="fa-solid fa-sack-dollar"></i></div><h5 className="jbs-list-pack">₹90K<span className="patype">/100 Days validity</span></h5></div>
													</div>
													<div className="jbs-list-head-last">
														<Link to="#" className="btn btn-md btn-gray px-3 me-2">View Detail</Link>
														<Link to="#" className="btn btn-md btn-main px-3">Quick Apply</Link>
													</div>
												</div>
											</div>
										</div>

									</div>
									{/* End All Job List */}
								</div>
							</div>

							{/* Company Review */}
							<div className="single-cdtsr-block">
								<div className="single-cdtsr-header"><h5>412 Reviews</h5></div>
								<div className="single-cdtsr-body">

									{/* single Review */}
									<div className="singleReviews border-bottom py-4">
										<div className="singlerev d-flex align-items-start justify-content-start gap-3">
											<div className="singlratebox bg-light rounded-3">
												<div className="px-3 py-4 text-center">
													<h3 className="text-main m-0">4.7</h3>
													<div className="d-flex align-items-center justify-content-center gap-1 text-xs">
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star-half text-warning"></i>
													</div>
												</div>
											</div>
											<div className="align-to-left reviewsCaption">
												<div className="reviewsHeader mb-3">
													<h5>Very professional and Smart Company</h5>
													<div className="d-flex align-items-center justify-content-start flex-wrap gap-2">
														<div className="text-muted text-md"><Link to="#" className="text-main">Freelance VizRT</Link>(Current Employee).</div>
														<div className="text-muted text-md"><Link to="#" className="text-main">Washington, DC</Link>.</div>
														<div className="text-muted text-md">November 15 2023</div>
													</div>
												</div>

												<div className="reviewsDescription">
													<p>
														<span className="d-block">What is the best part of working at the company?</span>
														<span>Communication between the operation employees is top notch. Everyone is on the same page. Always plan ahead for the both live and pre recorded events.</span>
													</p>
													<p>
														<span className="d-block">What is the most stressful part about working at the company?</span>
														<span>Relationship between employees is somewhat neutral unless there are sides and that’s when it gets awkward</span>
													</p>
													<p>
														<span className="d-block">What is the work environment and culture like at the company?</span>
														<span>Mostly professional, everyone keeps to themselves.</span>
													</p>
													<p>
														<span className="d-block">What is a typical day like for you at the company?</span>
														<span>My shift always start a couple of hours before going live and during this time I have to go through the rundown make sure everything is in place.</span>
													</p>
												</div>

												<div className="d-block mt-4">
													<div className="text-muted text-md mb-1">Was this review helpful?</div>
													<div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
														<div className="d-first">
															<div className="btn-group" role="group" aria-label="Basic outlined example">
																<button type="button" className="btn btn-md btn-outline-main">Yes</button>
																<button type="button" className="btn btn-md btn-outline-main">No</button>
															</div>
														</div>
														<div className="d-last d-flex align-items-center justify-content-end gap-3">
															<Link to="#" className="text-dark fw-medium"><i className="fa-regular fa-flag me-2"></i>Report</Link>
															<Link to="#" className="text-dark fw-medium"><i className="fa-solid fa-up-right-from-square me-2"></i>Share</Link>
														</div>
													</div>
												</div>

											</div>
										</div>

									</div>

									{/* single Review */}
									<div className="singleReviews border-bottom py-4">
										<div className="singlerev d-flex align-items-start justify-content-start gap-3">
											<div className="singlratebox bg-light rounded-3">
												<div className="px-3 py-4 text-center">
													<h3 className="text-main m-0">4.4</h3>
													<div className="d-flex align-items-center justify-content-center gap-1 text-xs">
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star-half text-warning"></i>
													</div>
												</div>
											</div>
											<div className="align-to-left reviewsCaption">
												<div className="reviewsHeader mb-3">
													<h5>Superb Company & Services</h5>
													<div className="d-flex align-items-center justify-content-start flex-wrap gap-2">
														<div className="text-muted text-md"><Link to="#" className="text-main">Freelance VizRT</Link>(Current Employee).</div>
														<div className="text-muted text-md"><Link to="#" className="text-main">Washington, DC</Link>.</div>
														<div className="text-muted text-md">July 10 2023</div>
													</div>
												</div>

												<div className="reviewsDescription">
													<p>
														<span className="d-block">What is the best part of working at the company?</span>
														<span>Communication between the operation employees is top notch. Everyone is on the same page. Always plan ahead for the both live and pre recorded events.</span>
													</p>
													<p>
														<span className="d-block">What is the most stressful part about working at the company?</span>
														<span>Relationship between employees is somewhat neutral unless there are sides and that’s when it gets awkward</span>
													</p>
													<p>
														<span className="d-block">What is the work environment and culture like at the company?</span>
														<span>Mostly professional, everyone keeps to themselves.</span>
													</p>
													<p>
														<span className="d-block">What is a typical day like for you at the company?</span>
														<span>My shift always start a couple of hours before going live and during this time I have to go through the rundown make sure everything is in place.</span>
													</p>
												</div>

												<div className="d-block mt-4">
													<div className="text-muted text-md mb-1">Was this review helpful?</div>
													<div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
														<div className="d-first">
															<div className="btn-group" role="group" aria-label="Basic outlined example">
																<button type="button" className="btn btn-md btn-outline-main">Yes</button>
																<button type="button" className="btn btn-md btn-outline-main">No</button>
															</div>
														</div>
														<div className="d-last d-flex align-items-center justify-content-end gap-3">
															<Link to="#" className="text-dark fw-medium"><i className="fa-regular fa-flag me-2"></i>Report</Link>
															<Link to="#" className="text-dark fw-medium"><i className="fa-solid fa-up-right-from-square me-2"></i>Share</Link>
														</div>
													</div>
												</div>

											</div>
										</div>

									</div>

									{/* single Review */}
									<div className="singleReviews border-bottom py-4">
										<div className="singlerev d-flex align-items-start justify-content-start gap-3">
											<div className="singlratebox bg-light rounded-3">
												<div className="px-3 py-4 text-center">
													<h3 className="text-main m-0">2.3</h3>
													<div className="d-flex align-items-center justify-content-center gap-1 text-xs">
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-regular fa-star text-warning"></i>
														<i className="fa-regular fa-star text-warning"></i>
														<i className="fa-regular fa-star text-warning"></i>
													</div>
												</div>
											</div>
											<div className="align-to-left reviewsCaption">
												<div className="reviewsHeader mb-3">
													<h5>Very Bad Management</h5>
													<div className="d-flex align-items-center justify-content-start flex-wrap gap-2">
														<div className="text-muted text-md"><Link to="#" className="text-main">Freelance VizRT</Link>(Current Employee).</div>
														<div className="text-muted text-md"><Link to="#" className="text-main">Washington, DC</Link>.</div>
														<div className="text-muted text-md">August 20 2023</div>
													</div>
												</div>

												<div className="reviewsDescription">
													<p>
														<span className="d-block">What is the best part of working at the company?</span>
														<span>Communication between the operation employees is top notch. Everyone is on the same page. Always plan ahead for the both live and pre recorded events.</span>
													</p>
													<p>
														<span className="d-block">What is the most stressful part about working at the company?</span>
														<span>Relationship between employees is somewhat neutral unless there are sides and that’s when it gets awkward</span>
													</p>
													<p>
														<span className="d-block">What is the work environment and culture like at the company?</span>
														<span>Mostly professional, everyone keeps to themselves.</span>
													</p>
													<p>
														<span className="d-block">What is a typical day like for you at the company?</span>
														<span>My shift always start a couple of hours before going live and during this time I have to go through the rundown make sure everything is in place.</span>
													</p>
												</div>

												<div className="d-block mt-4">
													<div className="text-muted text-md mb-1">Was this review helpful?</div>
													<div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
														<div className="d-first">
															<div className="btn-group" role="group" aria-label="Basic outlined example">
																<button type="button" className="btn btn-md btn-outline-main">Yes</button>
																<button type="button" className="btn btn-md btn-outline-main">No</button>
															</div>
														</div>
														<div className="d-last d-flex align-items-center justify-content-end gap-3">
															<Link to="#" className="text-dark fw-medium"><i className="fa-regular fa-flag me-2"></i>Report</Link>
															<Link to="#" className="text-dark fw-medium"><i className="fa-solid fa-up-right-from-square me-2"></i>Share</Link>
														</div>
													</div>
												</div>

											</div>
										</div>

									</div>

									{/* single Review */}
									<div className="singleReviews border-bottom py-4">
										<div className="singlerev d-flex align-items-start justify-content-start gap-3">
											<div className="singlratebox bg-light rounded-3">
												<div className="px-3 py-4 text-center">
													<h3 className="text-main m-0">4.9</h3>
													<div className="d-flex align-items-center justify-content-center gap-1 text-xs">
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star text-warning"></i>
														<i className="fa-solid fa-star-half text-warning"></i>
													</div>
												</div>
											</div>
											<div className="align-to-left reviewsCaption">
												<div className="reviewsHeader mb-3">
													<h5>One of The Best Company in Canada</h5>
													<div className="d-flex align-items-center justify-content-start flex-wrap gap-2">
														<div className="text-muted text-md"><Link to="#" className="text-main">Freelance VizRT</Link>(Current Employee).</div>
														<div className="text-muted text-md"><Link to="#" className="text-main">Washington, DC</Link>.</div>
														<div className="text-muted text-md">July 27 2022</div>
													</div>
												</div>

												<div className="reviewsDescription">
													<p>
														<span className="d-block">What is the best part of working at the company?</span>
														<span>Communication between the operation employees is top notch. Everyone is on the same page. Always plan ahead for the both live and pre recorded events.</span>
													</p>
													<p>
														<span className="d-block">What is the most stressful part about working at the company?</span>
														<span>Relationship between employees is somewhat neutral unless there are sides and that’s when it gets awkward</span>
													</p>
													<p>
														<span className="d-block">What is the work environment and culture like at the company?</span>
														<span>Mostly professional, everyone keeps to themselves.</span>
													</p>
													<p>
														<span className="d-block">What is a typical day like for you at the company?</span>
														<span>My shift always start a couple of hours before going live and during this time I have to go through the rundown make sure everything is in place.</span>
													</p>
												</div>

												<div className="d-block mt-4">
													<div className="text-muted text-md mb-1">Was this review helpful?</div>
													<div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
														<div className="d-first">
															<div className="btn-group" role="group" aria-label="Basic outlined example">
																<button type="button" className="btn btn-md btn-outline-main">Yes</button>
																<button type="button" className="btn btn-md btn-outline-main">No</button>
															</div>
														</div>
														<div className="d-last d-flex align-items-center justify-content-end gap-3">
															<Link to="#" className="text-dark fw-medium"><i className="fa-regular fa-flag me-2"></i>Report</Link>
															<Link to="#" className="text-dark fw-medium"><i className="fa-solid fa-up-right-from-square me-2"></i>Share</Link>
														</div>
													</div>
												</div>

											</div>
										</div>

									</div>

								</div>

								<div className="pagfooter mx-auto mb-3">
									<nav aria-label="Page navigation example" className="justify-content-center align-items-center">
										<ul className="pagination">
											<li className="page-item">
												<Link className="page-link" to="#" aria-label="Previous">
													<span aria-hidden="true">«</span>
												</Link>
											</li>
											<li className="page-item"><Link className="page-link" to="#">1</Link></li>
											<li className="page-item"><Link className="page-link" to="#">2</Link></li>
											<li className="page-item active"><Link className="page-link" to="#">3</Link></li>
											<li className="page-item"><Link className="page-link" to="#">4</Link></li>
											<li className="page-item"><Link className="page-link" to="#">5</Link></li>
											<li className="page-item"><Link className="page-link" to="#">6</Link></li>
											<li className="page-item">
												<Link className="page-link" to="#" aria-label="Next">
													<span aria-hidden="true">»</span>
												</Link>
											</li>
										</ul>
									</nav>
								</div>

							</div>

						</div>
					</div>

					<div className="col-xl-4 col-lg-4 col-md-12">

						<div className="card shadow-sm border-0 rounded-4 overflow-hidden" style={{ maxWidth: "360px" }}>
							{/* Top Image */}
							<img
								src={`${process.env.PUBLIC_URL}/assets/img/holding-educational.jpg`}
								className="card-img-top"
								alt="PPL All Subjects" />

							<div className="card-body align-to-left">
								{/* Validity */}
								<p className="text-muted mb-2"><i className="bi bi-clock me-2"></i> 90 Days validity</p>

								{/* Price + Discount */}
								<div className="d-flex align-items-center mb-3">
									<span className="fw-bold fs-5 me-2">₹ 699</span>
									<span className="text-muted text-decoration-line-through me-2">R 799</span>
									<span className="badge bg-warning text-dark">13% OFF</span>
								</div>

								{/* Buy Button */}
								<button className="btn btn-md btn-main px-3 w-100">
									BUY BUNDLE
								</button>

								{/* What's included */}
								<div className="border-top pt-3">
									<h6 className="fw-semibold mb-2">What's included</h6>
									<p className="mb-0 text-muted">
										<i className="bi bi-journal-text me-2"></i> 8 Test Series
									</p>
								</div>
							</div>
						</div>
						<div className="card-body align-to-left">
							{/* Validity */}
							<p className=" mb-2">Other pricing Plans</p>

						</div>

						<div className="card shadow-sm border-0 rounded-4 overflow-hidden" style={{ maxWidth: "360px" }}>
							<div className="card-body align-to-left">
								{/* Validity */}
								<p className="text-muted mb-2">Subject for 180 days</p>

								<div className="row mb-3">
									<div className="col-xl-9 col-lg-9 col-md-12">
										<p>The payment option is for students with international... </p>
									</div>
									<div className="col-xl-3 col-lg-3 col-md-12">
										<Link to="#" className="text-dark fw-medium">Details</Link>
									</div>
								</div>
								{/* Price + Discount */}
								<div className="d-flex align-items-center mb-3">
									<span className="fw-bold fs-5 me-2">₹ 699</span>
									<span className="text-muted text-decoration-line-through me-2">R 799</span>
									<span className="badge bg-warning text-dark">13% OFF</span>
								</div>

								{/* Buy Button */}
								<button className="btn btn-md btn-main px-3">BUY Now</button>
							</div>
						</div>

						<div className="card shadow-sm border-0 rounded-4 overflow-hidden" style={{ maxWidth: "360px" }}>
							<div className="card-body align-to-left">
								{/* Validity */}
								<p className="text-muted mb-2">Subject for 365 days</p>

								<div className="row mb-3">
									<div className="col-xl-9 col-lg-9 col-md-12">
										<p>The payment option is for students with international... </p>
									</div>
									<div className="col-xl-3 col-lg-3 col-md-12">
										<Link to="#" className="text-dark fw-medium">Details</Link>
									</div>
								</div>
								{/* Price + Discount */}
								<div className="d-flex align-items-center mb-3">
									<span className="fw-bold fs-5 me-2">₹ 699</span>
									<span className="text-muted text-decoration-line-through me-2">R 799</span>
									<span className="badge bg-warning text-dark">13% OFF</span>
								</div>

								{/* Buy Button */}
								<button className="btn btn-md btn-main px-3">BUY Now</button>
							</div>
						</div>
					</div>

				</div>
				{/* /row */}
			</div>
		</section>
	);
}